<template>
  <a-row :gutter="24" style="height: 100%">
    <a-col :md="24" :sm="24" style="height: 100%">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="5" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('分析类型')">
                <a-radio-group button-style="solid" v-model="queryParam.type" >
                  <a-radio-button value="1">{{ $t('按年') }}</a-radio-button>
                  <a-radio-button value="2">{{ $t('按月') }}</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xl="8" :lg="7" :md="8" :sm="24" v-if="queryParam.type == 1">
              <a-form-item :label="$t('年月选择')">
                <div style="display: flex">
                  <a-month-picker
                    value-format="YYYY-MM"
                    v-model="queryParam.beginDate"
                    :disabled-date="disabledDate1"
                    :placeholder="$t('请选择开始月份')"
                    @change="onChange1"
                  />
                  ~
                  <a-month-picker
                    value-format="YYYY-MM"
                    v-model="queryParam.endDate"
                    :disabled-date="disabledDate2"
                    :placeholder="$t('请选择结束月份')"
                    @change="onChange2"
                  />
                </div>
              </a-form-item>
            </a-col>
            <a-col :xl="8" :lg="7" :md="8" :sm="24" v-if="queryParam.type == 2">
              <a-form-item :label="$t('日期选择')">
                <a-range-picker
                  v-model="date"
                  format="YYYY-MM-DD"
                  :placeholder="[$t('查询起始日'), $t('查询结束日')]"
                  @change="onDateRangeChange"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <!-- <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div class="table-fixed">
        <div class="radio_button_group">
          <a-radio-group button-style="solid" v-model="radioValue" style="margin-bottom: 16px" @change="changeRadio">
            <a-radio-button value="1"><a-icon type="unordered-list" /></a-radio-button>
            <a-radio-button value="2"><a-icon type="bar-chart" /></a-radio-button>
          </a-radio-group>
        </div>
        <div v-if="radioValue == 1">
          <a-card size="small" :title="$t('多用户同比分析')">
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: true }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource1"
              :pagination="false"
              :loading="loading"
              @change="handleTableChange"
            >
            </a-table>
          </a-card>
          <!-- <a-card size="small" :title="$t('多用户环比分析')">
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: true }"
              bordered
              rowKey="id"
              :columns="columns1"
              :dataSource="dataSource2"
              :pagination="false"
              :loading="loading"
              @change="handleTableChange"
            >
            </a-table>
          </a-card> -->
        </div>
        <div style="height: 100%" v-if="radioValue == 2">
          <a-card size="small" :title="$t('多用户同比分析')">
            <div id="chart1" style="width: 100%; height: 300px"></div>
          </a-card>
          <a-card size="small" :title="$t('多用户环比分析')">
            <div id="chart2" style="width: 100%; height: 300px"></div>
          </a-card>
        </div>
      </div>
    </a-col>
  </a-row>
</template>
      <script>
import { getAction, deleteAction, postAction } from '@/api/manage'
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import TableDragResize from '@/mixins/TableDragResize'
import JInput from '@/components/jeecg/JInput'
import configService from '@/utils/service/config.service'
import { listSize } from '@/utils/util'
import Vue from 'vue'
import * as echarts from 'echarts'
import moment from 'moment'
export default {
  name: 'allIndex',
  mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
  components: {
    JInput,
  },
  data() {
    return {
      collapsed: false,
      data: [],
      visible: false,
      url: {
        list: '/jeecg-charge/meter/meterUserinfo/list',
        getCurveOnYearByYear: '/jeecg-charge/importantUser/getCurveOnYearByYear', // 年同比
        getCurveOnYearByMonth: '/jeecg-charge/importantUser/getCurveOnYearByMonth', // 月同比
        getCurveOnMonthByYear: '/jeecg-charge/importantUser/getCurveOnMonthByYear', // 年环比
        getCurveOnMonthByMonth: '/jeecg-charge/importantUser/getCurveOnMonthByMonth', // 月环比
        pageOnYearByYear: '/jeecg-charge/importantUser/pageOnYearByYear', // 年同比分页
        pageOnYearByMonth: '/jeecg-charge/importantUser/pageOnYearByMonth', // 月同比分页
      },
      dataSource1: [],
      dataSource2: [],
      radioValue: '1',
      meterIdList: [],
      queryParam: {
        type: '1',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${configService.apiUrl}/${this.url.importExcelUrl}`
    },
    // i18n：表头使用 computed 以响应语言切换
    columns1() {
      return [
        {
          title: this.$t('用户名称'),
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: this.$t('当前年度总用水量'),
          dataIndex: 'currentFlowSum',
          align: 'center',
        },
        {
          title: this.$t('上年度总用水量'),
          dataIndex: 'lastFlowSum',
          align: 'center',
        },
        {
          title: this.$t('同比变化量'),
          dataIndex: 'diffFlowSum',
          align: 'center',
        },
        {
          title: this.$t('同比变化百分比'),
          dataIndex: 'rate',
          align: 'center',
        },
      ]
    },
    columns2() {
      return [
        {
          title: this.$t('用户名称'),
          dataIndex: 'userName',
          align: 'center',
        },
        {
          title: this.$t('当前月度总用水量'),
          dataIndex: 'currentFlowSum',
          align: 'center',
        },
        {
          title: this.$t('上月度总用水量'),
          dataIndex: 'lastFlowSum',
          align: 'center',
        },
        {
          title: this.$t('同比变化量'),
          dataIndex: 'diffFlowSum',
          align: 'center',
        },
        {
          title: this.$t('同比变化百分比'),
          dataIndex: 'rate',
          align: 'center',
        },
      ]
    },
    columns() {
      // 按年/按月切换表头（原 changeType 逻辑，i18n 后改由 computed 派生）
      return this.queryParam.type == '1' ? this.columns1 : this.columns2
    },
  },
  methods: {
    init(ids) {
      this.meterIdList = ids
    },
    searchReset() {
      this.queryParam = {
        type: '1',
      }
    },
    searchQuery() {
      if (this.radioValue == 1) {
        if (this.queryParam.type == 1){
          this.pageOnYearByYear()
        }else{
          this.pageOnYearByMonth()
        }
      } else {
        this.$nextTick(() => {
          if (this.queryParam.type == 1) {
            this.getCurveOnYearByYear()
            this.getCurveOnMonthByYear()
          } else {
            this.getCurveOnYearByMonth()
            this.getCurveOnMonthByMonth()
          }
        })
      }
    },
    disabledDate1(current) {
      return current && current > moment(this.queryParam.endDate).endOf('day')
    },
    disabledDate2(current) {
      return current && current < moment(this.queryParam.beginDate).startOf('day')
    },
    onChange1(e) {
      if (e) {
        this.$set(this.queryParam, 'beginDate', `${e}-01`)
        this.$set(this.queryParam, 'compareBeginDate', moment(e).subtract(1, 'year').format('YYYY-MM-DD'))
      }
    },
    onChange2(e) {
      if (e) {
        this.$set(this.queryParam, 'endDate', `${e}-01`)
        this.$set(this.queryParam, 'compareEndDate', moment(e).subtract(1, 'year').format('YYYY-MM-DD'))
      }
    },
    // 获取年同比
    getCurveOnYearByYear() {
      let params = {
        meterIdList: this.meterIdList,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
        compareBeginDate: this.queryParam.compareBeginDate,
        compareEndDate: this.queryParam.compareEndDate,
      }
      postAction(this.url.getCurveOnYearByYear, params).then(res => {
        if (res.success) {
          this.setChart1(res.result)
        }
      })
    },
    // 获取月同比
    getCurveOnYearByMonth() {
      let params = {
        meterIdList: this.meterIdList,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
        compareBeginDate: this.queryParam.compareBeginDate,
        compareEndDate: this.queryParam.compareEndDate,
      }
      postAction(this.url.getCurveOnYearByMonth, params).then(res => {
        if (res.success) {
          this.setChart1(res.result)
        }
      })
    },
    // 获取年环比
    getCurveOnMonthByYear() {
      let params = {
        meterIdList: this.meterIdList,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
      }
      postAction(this.url.getCurveOnMonthByYear, params).then(res => {
        if (res.success) {
          this.setChart2(res.result)
        }
      })
    },
    // 获取月环比
    getCurveOnMonthByMonth() {
      let params = {
        meterIdList: this.meterIdList,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
      }
      postAction(this.url.getCurveOnMonthByMonth, params).then(res => {
        if (res.success) {
          this.setChart2(res.result)
        }
      })
    },
    // 获取年同比分页
    pageOnYearByYear() {
      let params = {
        meterIdList: this.meterIdList,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
        compareBeginDate: this.queryParam.compareBeginDate,
        compareEndDate: this.queryParam.compareEndDate,
        page:{
          current:1,
          size:1000
        }
      }
      postAction(this.url.pageOnYearByYear, params).then(res => {
        if (res.success) {
          this.dataSource1 = res.result.records;
        }
      })
    },
    // 获取月同比分页
    pageOnYearByMonth() {
      let params = {
        meterIdList: this.meterIdList,
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
        page:{
          current:1,
          size:1000
        }
      }
      postAction(this.url.pageOnYearByMonth, params).then(res => {
        if (res.success) {
          this.dataSource1 = res.result.records;
        }
      })
    },
    changeRadio(e) {
      if (e.target.value == 1) {
        if (this.queryParam.type == 1){
          this.pageOnYearByYear()
        }else{
          this.pageOnYearByMonth()
        }
      } else {
        this.$nextTick(() => {
          if (this.queryParam.type == 1) {
            this.getCurveOnYearByYear()
            this.getCurveOnMonthByYear()
          } else {
            this.getCurveOnYearByMonth()
            this.getCurveOnMonthByMonth()
          }
        })
      }
    },
    setChart1(data) {
      let xData1 = data[0].curve.curveDataList.map(item => item.time.split(' ')[0])
      let legendData1 = [...new Set(data.map(item => item.userName))]
      let seriesData1 = data.map(item => {
        if (item.curve.formatFlag == 0) {
          return {
            name: `${item.userName}[${this.queryParam.beginDate.split('-')[0]}]`,
            type: 'line',
            data: item.curve.curveDataList.map(item => item.value),
            smooth: true,
          }
        } else {
          return {
            name: `${item.userName}[${this.queryParam.compareBeginDate.split('-')[0]}]`,
            type: 'line',
            data: item.curve.curveDataList.map(item => item.value),
            smooth: true,
            lineStyle: {
              type: 'dashed',
            },
          }
        }
      })
      let chart1 = echarts.init(document.getElementById('chart1'))
      chart1.setOption({
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: legendData1,
          orient: 'vertical',
          top: '10%',
          right: '2%',
        },
        xAxis: {
          data: xData1,
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
          {
            start: 0,
            end: 100,
          },
        ],
        yAxis: {},
        series: seriesData1,
      })
      window.addEventListener('resize', function () {
        chart1.resize()
      })
    },
    setChart2(data) {
      let xData2 = data[0].curve.curveDataList.map(item => item.time.split(' ')[0])
      let legendData2 = [...new Set(data.map(item => item.userName))]
      let seriesData2 = data.map(item => {
        if (item.curve.formatFlag == 0) {
          return {
            name: `${item.userName}[${this.queryParam.beginDate.split('-')[0]}]`,
            type: 'line',
            data: item.curve.curveDataList.map(item => item.value),
            min: item.curve.min,
            max: item.curve.max,
            smooth: true,
          }
        } else {
          return {
            name: `${item.userName}[${this.queryParam.compareBeginDate.split('-')[0]}]`,
            type: 'line',
            data: item.curve.curveDataList.map(item => item.value),
            min: item.curve.min,
            max: item.curve.max,
            smooth: true,
            lineStyle: {
              type: 'dashed',
            },
          }
        }
      })
      let chart2 = echarts.init(document.getElementById('chart2'))
      chart2.setOption({
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: legendData2,
          orient: 'vertical',
          top: '10%',
          right: '2%',
        },
        xAxis: {
          data: xData2,
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
          {
            start: 0,
            end: 100,
          },
        ],
        yAxis: {},
        series: seriesData2,
      })
      window.addEventListener('resize', function () {
        chart2.resize()
      })
    },
  },
}
</script>
      <style scoped lang="less">
.drawer-bootom-button {
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.qrcodeInfo {
  color: #222;
  margin: 5px 0;
}
</style>
      <style scoped>
.my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
}
</style>
      <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
.radio_button_group {
  position: absolute;
  right: 14px;
  top: 0;
}
/* .new-table-card .ant-card-body .table-fixed {
      height: calc(100% - 207px);
    } */
</style>